var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33355 8.13148C8.33355 7.99986 8.37251 7.87119 8.44552 7.76168L11.8179 2.70313C12.1132 2.26009 11.7956 1.66666 11.2632 1.66666H2.73725C2.20478 1.66666 1.88719 2.26009 2.18255 2.70313L5.55492 7.76168C5.62792 7.87119 5.66688 7.99986 5.66688 8.13148V12.0582C5.66688 12.5818 6.24285 12.901 6.68688 12.6235L8.02022 11.7902C8.21514 11.6683 8.33355 11.4547 8.33355 11.2248V8.13148ZM9.66688 8.53518C9.66688 8.40356 9.70584 8.27489 9.77885 8.16538L12.9273 3.44273C13.8134 2.11362 12.8606 0.333328 11.2632 0.333328H2.73725C1.13986 0.333328 0.187076 2.11362 1.07315 3.44273L4.22158 8.16538C4.29459 8.27489 4.33355 8.40356 4.33355 8.53518V12.0582C4.33355 13.629 6.06145 14.5867 7.39355 13.7542L8.72688 12.9208C9.31164 12.5554 9.66688 11.9144 9.66688 11.2248V8.53518Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c4558f68a4e60870849101def3d2632d.svg";
export { ForwardRef as ReactComponent };